import { render, staticRenderFns } from "./overviewMacro.vue?vue&type=template&id=36c17961&scoped=true&"
import script from "./overviewMacro.vue?vue&type=script&lang=js&"
export * from "./overviewMacro.vue?vue&type=script&lang=js&"
import style0 from "./overviewMacro.vue?vue&type=style&index=0&id=36c17961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c17961",
  null
  
)

export default component.exports